import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import brizo1 from './assets/images/brizo/brizo1.jpg';
import brizo2 from './assets/images/brizo/brizo2.jpg';
import brizo3 from './assets/images/brizo/brizo3.jpg';
import brizo4 from './assets/images/brizo/brizo4.jpg';
import brizo5 from './assets/images/brizo/brizo5.jpg';
import brizo6 from './assets/images/brizo/brizo6.jpg';
import brizo7 from './assets/images/brizo/brizo7.jpg';
import brizo8 from './assets/images/brizo/brizo8.jpg';
import brizo9 from './assets/images/brizo/brizo9.jpg';
import brizo10 from './assets/images/brizo/brizo10.jpg';
import brizo11 from './assets/images/brizo/brizo11.jpg';
import brizo12 from './assets/images/brizo/brizo12.jpg';
import brizo13 from './assets/images/brizo/brizo13.jpg';
import brizo14 from './assets/images/brizo/brizo14.jpg';
import brizo15 from './assets/images/brizo/brizo15.jpg';
import brizo16 from './assets/images/brizo/brizo16.jpg';
import brizo17 from './assets/images/brizo/brizo17.jpg';
import brizo18 from './assets/images/brizo/brizo18.jpg';


const photos = [
    { src: brizo1, ...SquarePhoto },
    { src: brizo2, ...SquarePhoto },
    { src: brizo3, ...WidePhoto },
    { src: brizo4, ...SquarePhoto },
    { src: brizo5, ...WidePhoto },
    { src: brizo6, ...WidePhoto },
    { src: brizo7, ...TallPhoto },
    { src: brizo8, ...SquarePhoto },
    { src: brizo9, ...SquarePhoto },
    { src: brizo10, ...SquarePhoto },
    { src: brizo11, ...SquarePhoto },
    { src: brizo12, ...SquarePhoto },
    { src: brizo13, ...SquarePhoto },
    { src: brizo14, ...SquarePhoto },
    { src: brizo15, ...WidePhoto },
    { src: brizo16, ...WidePhoto },
    { src: brizo17, ...TallPhoto },
    { src: brizo18, ...WidePhoto },
];

const Brizo = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="female">
                <i className="far fa-venus"></i>
                Brizo
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>ch lunanova's ancient mariner goddess of newriver</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA</td>
                        <td><span className="title">CKC Registration</span>#LL4263924</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>CH DOMARCO N DREWSAR WE WILL ROCK YOU</td>
                        <td><span className="title">Dam</span>GCH LUNANOVA'S BREWMASTER MELODY MAKER</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>Wavy</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Brizo;
